<script>
  // # # # # # # # # # # # # # # #
  //
  //  Mailing List Sign-Up Form
  //
  // # # # # # # # # # # # # # # #

  // *** PROPS
  export let title = "";
</script>

<style lang="scss">
  @import "../variables.scss";

  #mc_embed_signup {
    background: $grey;
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    z-index: 10000;

    .inner {
      width: 600px;
      max-width: 90%;
    }
  }
</style>

<!-- Begin Mailchimp Signup Form -->
<link
  href="//cdn-images.mailchimp.com/embedcode/classic-10_7.css"
  rel="stylesheet"
  type="text/css" />
<div id="mc_embed_signup">
  <form
    action="https://arielfeminisms.us18.list-manage.com/subscribe/post?u=24e9e8374cfc64d3e1c33f6f4&amp;id=cd9f919375"
    method="post"
    id="mc-embedded-subscribe-form"
    name="mc-embedded-subscribe-form"
    class="inner validate"
    target="_blank"
    novalidate>
    <div id="mc_embed_signup_scroll">
      <h2>Subscribe</h2>
      <div class="indicates-required">
        <span class="asterisk">*</span>
        indicates required
      </div>

      <div class="mc-field-group">
        <label for="mce-EMAIL">
          Email Address
          <span class="asterisk">*</span>
        </label>
        <input
          type="email"
          value=""
          name="EMAIL"
          class="required email"
          id="mce-EMAIL" />
      </div>

      <div class="mc-field-group">
        <label for="mce-FNAME">
          First Name
          <span class="asterisk">*</span>
        </label>
        <input
          type="text"
          value=""
          name="FNAME"
          class="required"
          id="mce-FNAME" />
      </div>

      <div class="mc-field-group">
        <label for="mce-LNAME">
          Last Name
          <span class="asterisk">*</span>
        </label>
        <input
          type="text"
          value=""
          name="LNAME"
          class="required"
          id="mce-LNAME" />
      </div>

      <div class="mc-field-group input-group">
        <strong>Select mailing lists</strong>
        <ul>
          <li>
            <input
              type="checkbox"
              value="1"
              name="group[6082][1]"
              id="mce-group[6082]-6082-0"
              checked={title == 'ariel'} />
            <label for="mce-group[6082]-6082-0">Ariel</label>
          </li>
          <li>
            <input
              type="checkbox"
              value="2"
              name="group[6082][2]"
              id="mce-group[6082]-6082-1"
              checked={title == 'ygrg'} />
            <label for="mce-group[6082]-6082-1">YGRG Archive</label>
          </li>
        </ul>
      </div>

      <div id="mce-responses" class="clear">
        <div class="response" id="mce-error-response" style="display:none" />
        <div class="response" id="mce-success-response" style="display:none" />
      </div>
      <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->

      <div style="position: absolute; left: -5000px;" aria-hidden="true">
        <input
          type="text"
          name="b_24e9e8374cfc64d3e1c33f6f4_cd9f919375"
          tabindex="-1"
          value="" />
      </div>

      <div class="clear">
        <input
          type="submit"
          value="Subscribe"
          name="subscribe"
          id="mc-embedded-subscribe"
          class="button" />
      </div>

    </div>
  </form>
</div>

<!-- <script type='text/javascript' src='//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js'></script> -->
<!-- <script type='text/javascript'>(function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]='EMAIL';ftypes[0]='email';fnames[1]='FNAME';ftypes[1]='text';fnames[2]='LNAME';ftypes[2]='text';}(jQuery));var $mcj = jQuery.noConflict(true);</script> -->
<!--End mc_embed_signup-->
